import React, { useRef, useState } from "react"
import { IInnRegistryDto } from "../../../types/inn/IInnRegistryDto"
import { ModalConfirm } from "../../common/element/ModalConfirm"
import { ModalPopUp } from "../../common/element/ModalPopUp"
import { IModalMessage } from "../../../types/error/IModalMessage"

export const InnPopUpListItem: React.FC<{
  inn: IInnRegistryDto
  remove: (inn: string) => void
  lockUnlock: (inn: IInnRegistryDto) => void
  approve: (inn: IInnRegistryDto) => void
}> = ({ inn, remove, lockUnlock, approve }) => {
  const [modalConfirm, setModalConfirm] = useState<IModalMessage>()
  const [modalMessage, setModalMessage] = useState<IModalMessage | null>(null)
  const userMenu = useRef<HTMLDivElement>(null)

  const getHumanStatus = (status: string | undefined) => {
    switch (status) {
      case "BLOCKED":
        return "Заблокирована"
      case "APPROVED":
        return "Одобрена"
      case "PENDING":
        return "Новая"
      default:
        return "Ошибка статуса"
    }
  }

  const toggleMenu = () => {
    if (userMenu.current) {
      if (userMenu.current.style.left === "0%") {
        userMenu.current.style.display = "none"
        userMenu.current.style.left = "100%"
      } else {
        userMenu.current.style.display = "flex"
        userMenu.current.style.left = "0%"
      }
      //userMenu.current.style.left = userMenu.current.style.left === "0%" ? "100%" : "0%";
    }
  }

  const lockUnlockHandler = () => {
    toggleMenu()
    lockUnlock(inn)
  }

  const approveHandler = () => {
    toggleMenu()
    approve(inn)
  }

  const confirmRemove = (val: any) => {
    if (val) {
      toggleMenu()
      remove(val)
    }
  }

  return (
    <>
      <ModalConfirm message={modalConfirm} setMessage={setModalConfirm} />
      <ModalPopUp message={modalMessage} close={() => setModalMessage(null)} />
      <li className="inn_item_new">
        <p className={`four-card-text`}>{inn.inn}</p>
        <p className="four-card-text">{inn.name || "-"}</p>
        <p className="four-card-text">{inn.address || "-"}</p>
        <p className="four-card-text width-200">{inn.clientInnList?.[0]?.user?.profile?.name || "-"}</p>
        <p className="four-card-text width-200 break-word-all">{inn.clientInnList?.[0]?.user?.username || "-"}</p>
        <p className="four-card-text">{inn.status ? getHumanStatus(inn.status) : "-"}</p>
        <button className="openmenu" onClick={toggleMenu} />
        <div id="menu-itemINN" ref={userMenu}>
          <p className="menu-cpmpany-button-blank" />
          {inn.status === "PENDING" ? (
            <p className="menu-cpmpany-button" onClick={approveHandler}>
              Одобрить
            </p>
          ) : (
            <p className="menu-cpmpany-button-blank" />
          )}
          <p
            className="menu-cpmpany-button"
            onClick={() =>
              setModalConfirm({
                title: "Удалить ИНН?",
                text: `Вы действительно желаете удалить ИНН ${inn.inn} (${inn.name})?`,
                callbackValue: inn.inn,
                _callback: confirmRemove
              })
            }
          >
            Удалить
          </p>
          <p className="menu-cpmpany-button" onClick={lockUnlockHandler}>
            {inn.status === "BLOCKED" ? "Разблокировать" : "Заблокировать"}
          </p>
          <button id="closemenuINN" onClick={toggleMenu} />
        </div>
      </li>
    </>
  )
}
